import axios from 'axios'
import { fileUrl } from 'src/utils/lib'

export const downloadFile = (link, fileName) => {
  axios({
    url: fileUrl(link),
    method: 'GET',
    responseType: 'blob',
  })
    .then((response) => {
      const href = URL.createObjectURL(response.data)
      const linkElement = document.createElement('a')
      linkElement.href = href
      linkElement.setAttribute('download', fileName)
      document.body.appendChild(linkElement)
      linkElement.click()
    })
    .catch((err) => console.log(err))
}

export const downloadAllFiles = async (data) => {
  const filteredData = await data.filter((item) => item.type === 'UploadFile')

  for (const element of filteredData) {
    downloadFile(element.link, element.name)
  }
}
